module.exports = __webpack_public_path__ + "static/hero-682e865e07b7187c0c7ceb3f95f869ee.png";